export * from "./jira-product-discovery.template";
